import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useParams} from "react-router-dom";

import * as actionTypes from "../../store/actions/actionTypes";
import {ifcLookupListSet} from "../../store/actions/ifcLookupList";
import IFCLookupList from "../../components/IFCLookup/IFCLookupList";

const IFCLookupView = () => {
    const dispatch = useDispatch();
    const params = useParams();
    const {hospitalId, keyword, sortColumn, sortMode, filter, page} = params;

    useEffect(() => {
        dispatch({type: actionTypes.MENU_IFC_LOOKUP});
        dispatch(ifcLookupListSet(hospitalId, keyword, filter, page, sortColumn, sortMode));
    }, [
        params.page, params.keyword
    ]);

    return (
        <>
            <IFCLookupList />
        </>
    );
}

export default IFCLookupView;